import { render } from "./sport-live-tv-alert-icon.vue?vue&type=template&id=2c597c6d&scoped=true"
const script = {}

import "./sport-live-tv-alert-icon.vue?vue&type=style&index=0&id=2c597c6d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c597c6d"]])

export default __exports__